import request from '../../../../util/APIUtils';
import { PORTAL_API_BASE_URL } from '../../../../constants';

/**
 * Portal returns a raw Response with HTTP 204 when the learner has no saved reentry plan.
 * @param {unknown} fetchResult
 * @returns {boolean}
 */
export const isReentryPlanHttp204NoContent = (fetchResult) =>
  fetchResult != null &&
  typeof fetchResult === 'object' &&
  typeof fetchResult.status === 'number' &&
  fetchResult.status === 204;

/**
 * Fetches Honest Jobs reentry plan data for a learner (saved jobs/resources).
 * @param {string|number} personId - Learner person id from case plan detail
 * @returns {Promise<object|null>} Parsed JSON body, or null when no plan exists (204)
 */
export const fetchLearnerReentryPlan = async (personId, signal) => {
  const response = await request({
    url: `${PORTAL_API_BASE_URL}/api/admin/learners/${personId}/reentry-plan`,
    method: 'GET',
    signal,
  });

  if (isReentryPlanHttp204NoContent(response)) {
    return null;
  }

  return response;
};
